module.exports = __webpack_public_path__ + "img/security.4c92db7a.jpg";